import {Component, Input, OnChanges} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {marked} from 'marked';

@Component({
  selector: 'app-markdown',
  imports: [],
  templateUrl: './markdown.component.html',
  styleUrl: './markdown.component.scss'
})
export class MarkdownComponent implements OnChanges {
  @Input() rawMarkdown = '';
  htmlContent: SafeHtml = '';

  constructor(private sanitizer: DomSanitizer) {
    marked.setOptions({breaks: true, gfm: true});
    const rawHtml = marked.parseInline(this.rawMarkdown) as string;
    this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(rawHtml);
  }

  async ngOnChanges() {
    const rawHtml = await marked.parseInline(this.rawMarkdown);
    this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(rawHtml);
  }
}
